import styled from '@emotion/styled';
import { DepartingType, Itinerary } from '@model/iceberg/common';
import React from 'react';
import { Icon } from '@components/common/generic-icon';
import { TestId } from '@components/test-ids';
import { TextMarkdown } from '@components/common/description';
import { ThemeProps } from '@theme/base';

export interface ItemProps {
  item: Itinerary;
}

const Subtitle = styled.div(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any),
  color: theme.custom.colors.group4.base
}));

const Paragraph = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any)
}));

const FlexContainer = styled.div({
  display: 'flex',
  alignItems: 'center'
});

const StyledIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  marginRight: theme.custom.spacing.xSmall,
  color: theme.custom.colors.group4.light,
  fontSize: '1.4rem'
}));

const DEPARTING_TYPE_ICONS = {
  [DepartingType.FLIGHT]: 'mhi-departure',
  [DepartingType.TRAIN]: ''
};

export const Item = ({ item: { place, meals, departingType, departingText, text } }: ItemProps) => {
  return (
    <>
      <Subtitle data-testid={TestId.itinerary.item.subtitle}>{place}</Subtitle>
      {departingText && departingType && (
        <FlexContainer>
          <StyledIcon name={DEPARTING_TYPE_ICONS[departingType]} testId={TestId.itinerary.item.departIcon} />
          <Paragraph data-testid={TestId.itinerary.item.departText}>{departingText}</Paragraph>
        </FlexContainer>
      )}
      {meals && (
        <FlexContainer>
          <StyledIcon name={'mhi-meal'} />
          <Paragraph data-testid={TestId.itinerary.item.meals}>{meals}</Paragraph>
        </FlexContainer>
      )}
      <TextMarkdown description={text} />
    </>
  );
};
